const demo_app = {
    notification: '알림:로그인 경험을 테스트하기 위해 먼저 계정을 만드는 것이 좋아요.',
};
export default demo_app;
